<app-modal [title]="'Warning!'" #modal>
  The system is currently undergoing maintenance. The portal will be available again in just a moment.
</app-modal>
